import AssetVulnerabilitiesTable from './AssetVulnerabilitiesTable';

export default AssetVulnerabilitiesTable;
export { AssetVulnerabilitiesTable };
